import { reactive } from "vue";

/* Estado global del PWA compartido por todos los botones de instalación.
 * canInstall se enciende cuando el navegador dispara beforeinstallprompt
 * (Chrome/Edge en PC y Android). En iOS Safari no existe ese evento, así que
 * el botón muestra la guía "Agregar a inicio". En modo standalone (app ya
 * instalada) el botón desaparece. */
export const pwa = reactive({
  canInstall: false,
  isInstalled: false,
  isIos: false,
});

let deferredPrompt = null;

function detectStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

function detectIos() {
  const ua = window.navigator.userAgent || "";
  const isIpadOs = window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1;
  return /iphone|ipad|ipod/i.test(ua) || isIpadOs;
}

export function initPwa() {
  pwa.isIos = detectIos();
  pwa.isInstalled = detectStandalone();

  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPrompt = event;
    pwa.canInstall = true;
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    pwa.canInstall = false;
    pwa.isInstalled = true;
  });

  window
    .matchMedia("(display-mode: standalone)")
    .addEventListener("change", (event) => {
      if (event.matches) {
        pwa.isInstalled = true;
        pwa.canInstall = false;
      }
    });

  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register(`${process.env.BASE_URL}service-worker.js`)
        .catch((error) => console.warn("PWA: no se pudo registrar el service worker", error));
    });
  }
}

export async function installPwa() {
  const promptEvent = deferredPrompt;
  if (!promptEvent) return "unavailable";

  deferredPrompt = null;
  promptEvent.prompt();
  const { outcome } = await promptEvent.userChoice;
  if (outcome === "accepted") {
    pwa.canInstall = false;
    pwa.isInstalled = true;
  }
  return outcome;
}
